import { Pipe, PipeTransform } from '@angular/core'
import { Channel, ChannelNameTokens } from '@tokeet/tv3-platform'

const icons = {
  [ChannelNameTokens.AgodaAPI]: 'assets/channels/agoda.png',
  [ChannelNameTokens.AirBnBV2API]: 'assets/channels/airbnb.svg',
  [ChannelNameTokens.AirBnBAPI]: 'assets/channels/airbnb.svg',
  [ChannelNameTokens.BookingAPI]: 'assets/channels/booking.png',
  [ChannelNameTokens.ExpediaAPI]: 'assets/channels/expedia.png',
  [ChannelNameTokens.HomeToGo]: 'assets/channels/hometogo.png',
  [ChannelNameTokens.Homeaway]: 'assets/channels/vrbo.png',
  [ChannelNameTokens.Hvmi]: 'assets/channels/homevillas.png',
  [ChannelNameTokens.RentalsUnited]: 'assets/channels/rentalsunited.png',
  [ChannelNameTokens.Holidu]: 'assets/channels/holidu.png',
  [ChannelNameTokens.Tiket]: 'assets/channels/tiket.png',
  [ChannelNameTokens.FlipKeyAPI]: 'assets/channels/airbnb.svg',
  [ChannelNameTokens.GoogleVacationRentals]: 'assets/channels/google_vacation_rentals.png',
  ['webready']: 'assets/channels/webready.png',
  [ChannelNameTokens.Trip]: 'assets/channels/trip.com.png',

  [ChannelNameTokens.AirBnBICal]: 'assets/channels/airbnb.svg',
  [ChannelNameTokens.ClearTripICal]: 'assets/channels/cleartrip.png',
  [ChannelNameTokens.EbabICal]: 'assets/channels/ebab.png',
  [ChannelNameTokens.FlipKeyICal]: 'assets/channels/flipkey.png',
  [ChannelNameTokens.HolidayLettingsICal]: 'assets/channels/holiday-lettings.png',
  [ChannelNameTokens.HouseTripICal]: 'assets/channels/housetrip.png',
  [ChannelNameTokens.TripvillasICal]: 'assets/channels/tripvillas.png',
  [ChannelNameTokens.VacationHomeRentalsICal]: 'assets/channels/vhr.png',
  ['vacationrentals']: 'assets/channels/vacation-rentals.png',
  [ChannelNameTokens.VacationRentalsICal]: 'assets/channels/vacation-rentals.png',
  [ChannelNameTokens.VrboICal]: 'assets/channels/home-away.png',
  ['VRBO']: 'assets/channels/home-away.png',
  [ChannelNameTokens.WimduICal]: 'assets/channels/wimdu.png',
  [ChannelNameTokens.UnknownICal]: 'assets/channels/unknown.png',
}

@Pipe({
  name: 'channelIcon',
})
export class ChannelIconPipe implements PipeTransform {
  transform(channel: Channel | string) {
    let nameToken
    if (typeof channel === 'string') {
      nameToken = channel
    } else {
      nameToken = channel.name
    }
    const icon = icons[nameToken]
    if (!icon) {
      return ''
    }

    return icon
  }
}
